import { supabase } from './supabase'

export async function callClaude({ system, prompt, max_tokens = 1000 }) {
  const { data: { session } } = await supabase.auth.getSession()
  const accessToken = session?.access_token

  if (!accessToken) {
    throw new Error('You must be signed in to use AI features.')
  }

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
  const response = await fetch(supabaseUrl + '/functions/v1/claude', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
      'Authorization': 'Bearer ' + accessToken
    },
    body: JSON.stringify({
      system,
      max_tokens,
      messages: [{ role: 'user', content: prompt }]
    })
  })

  if (!response.ok) {
    const error = await response.json()
    console.error('Edge function error:', response.status, JSON.stringify(error))
    throw new Error(error.error || 'AI request failed: ' + response.status)
  }

  const data = await response.json()
  return data.content
}
